import { EActivityCategories } from './Activities.domain';

export enum EStatusLink {
    EMPTY = '',
    MIN_TICKETS = 'min-tickets',
    TICKETS = 'tickets',
    IS_CHILD = 'is-child',
    ADDITIONAL_OPTIONS = 'additional_options',
    TIPS = 'tips',
    CANCELLATION_INFO = 'cancellation-info',
    ADD_TO_CART = 'add-to-cart',
}

export interface IDaysAvailability {
    [key: string]: number;
}

export interface IAvailability {
    days_availability: IDaysAvailability;
    id: number;
    price: number;
    price_strike_out: number | null;
    price_strike_out_subunits: number | null;
    price_subunits: number;
    use_calendar: number;
}

export type TAvailabilityFullParams = {
    id: string;
    from: string;
    to: string;
    promocode?: string;
};

export type TAvailabilityRates = {
    days_info: DaysInfoRates[];
    use_calendar: '0' | '1';
    use_schedule: '0' | '1';
    use_rates: '0' | '1';
};

export interface DaysInfoRates {
    rates: TRate[];
    date: string;
    id: string;
    is_avail: boolean;
    min_price: number;
    min_price_subunits: number;
    product_city_id: string;
    product_id: string;
    product_name: string;
    tickets_avail: number;
}

export type TRate = {
    rate_id: number;
    rate_name: string;
    schedules: Schedule[];
    additional_options: AdditionalOption[];
    is_avail: boolean;
    tickets_avail: number;
};

export interface AdditionalOption {
    format_type: string;
    id: string;
    is_disabled: string;
    name: string;
    required: string;
    rs_internal: string;
    type: string;
    values: Value[];
}

export interface Value {
    apply_tax: string;
    comission: string;
    id: string;
    is_disabled: string;
    name: string;
    price: string;
    price_subunits: number;
}

export interface Schedule {
    admin_only: boolean;
    has_lowest_price: number;
    id: number;
    inventories: Inventory[];
    min_price: number;
    min_price_subunits: number;
    min_tickets: string;
    sold_out: boolean;
    tickets: Ticket[];
    tickets_avail: number;
    tickets_total: number;
    time: string;
    category: EActivityCategories;
}

export interface Inventory {
    avail: number;
    duration?: string;
    id: string;
}

export interface Ticket {
    avail: number;
    description: string;
    duration: string;
    id: number;
    is_child: string;
    min: string;
    name: string;
    name_format: string;
    price: number;
    price_subunits: number;
    strike_out: number;
    strike_out_subunits: number;
}

export type TScheduleShort = {
    date: string;
    time: string;
    trip_id: string;
    id: string;
    name: string;
    category: EActivityCategories;
    isAvail: boolean;
    ticketsAvail: number;
    price?: number;
    compare_price?: number;
};

export type TDay = {
    day: number;
    name: string;
    shortName: string;
    schedules: TScheduleShort[];
};

export type TAvailByMonthResp = {
    available_dates: string[];
};

export type TTickets = Record<'avail' | 'total', number>;

export type TSchedule = {
    time: string;
    schedule_id: number;
    is_avail: boolean;
    call_to_booking: boolean;
    tickets: TTickets;
    description: string;
    price?: number;
    min_tickets?: number;
    durations?: string;
};

export type TDayItem = {
    trip_id: number;
    trip_name: string;
    need_ticket_names: boolean;
    schedules: TSchedule[];
    has_overnights?: boolean;
    call_to_booking?: boolean;
};

export type TAvailByDayResp = TDayItem[];
